export function SmartphoneIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path fill="currentColor" d="M12 17a1 1 0 100 2h.01a1 1 0 100-2H12z"></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.429 2C6.884 2 6 3.481 6 4.8v14.4c0 1.319.884 2.8 2.429 2.8h7.142C17.116 22 18 20.518 18 19.2V4.8c0-1.319-.884-2.8-2.429-2.8H8.43zM8 4.8c0-.288.094-.515.202-.651.107-.135.194-.149.227-.149H10a1 1 0 001 1h2a1 1 0 001-1h1.571c.033 0 .12.014.227.149.108.136.202.363.202.651v14.4c0 .288-.094.515-.202.651-.107.135-.194.149-.227.149H8.43c-.033 0-.12-.014-.227-.149A1.057 1.057 0 018 19.2V4.8z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
